import React from 'react';
import ExternalLanding from "./ExternalLanding";

const ExclusiveWebinar = () => {
  return (
    <ExternalLanding url="https://launch.secur.space/exclusive-webinar-access-expert-insights-strategies" height="100%" />
  )
}

export default ExclusiveWebinar